<template>
    <div id="sign-in-form-1">
        <div class="form-body" v-if="email">
            <div class="login-title">
                <p class="title is-3">{{ $t("Forget password") }}</p>
            </div>

            <div
                class="level"
                style="margin-bottom: 0; display: flex; height: 200px"
            >
                <div class="info">
                    <img src="@/assets/images/mail.svg" />
                    <p>
                        <span
                            :class="[
                                { error: error },
                                { success: !error && !loading },
                            ]"
                            >{{ $t(message) }}</span
                        >
                        <br />
                        <span class="email" v-if="!error">{{ email }}</span>
                    </p>
                </div>
            </div>
            <Loading v-if="loading" />
            <div
                style="
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 0;
                    height: 150px;
                "
            >
                <button
                    class="auth-button"
                    @click="$router.push({ name: 'sign-in-password' })"
                >
                    {{ $t("Back") }}
                </button>
                <button
                    class="auth-button primary-btn"
                    v-if="!loading"
                    @click="forgetPassword(email)"
                >
                    {{ $t("Resend code") }}
                </button>
            </div>
            <hr />
            <div
                class="form-footer form-gray"
                style="height: 40px; padding: 15px 0"
            >
                <p>
                    {{ $t("Protected by ALKOON and subject to our") }}
                    <a
                        target="_blank"
                        href="https://alkoonshipping.com/privacy_and_security.html"
                    >
                        <span class="has-text-primary" style="cursor: pointer">
                            {{ $t("Privacy Policy") }}
                        </span>
                    </a>
                    <span>{{ $t(" and ") }}</span>
                    <a
                        target="_blank"
                        href="https://alkoonshipping.com/terms_and_conditions.html"
                    >
                        <span class="has-text-primary" style="cursor: pointer">
                            {{ $t("Terms of Service.") }}
                        </span>
                    </a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import patterns from "@/validations/patterns";
import Loading from "@/components/Loading";

export default {
    components: {
        Loading,
    },
    data() {
        return {
            loading: true,
            email: null,
            message: "Please wait, we are sending email to",
            error: false,
        };
    },
    methods: {
        forgetPassword(email) {
            this.loading = true;
            this.error = false;
            this.message = "Please wait, we are sending email to";
            this.$store
                .dispatch("forgetPassword", {
                    email: email,
                })
                .then((res) => {
                    if (res.status === 200) {
                        this.error = false;
                        this.message = this.$t(
                            "Please check your email, We had sent to"
                        );
                    }
                })
                .catch((err) => {
                    this.message = this.$t(err.message);
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    created() {
        if (!localStorage.getItem("email")) {
            this.$router.push({
                name: "sign-in-email",
            });
        }
        this.email = localStorage.getItem("email");
        this.forgetPassword(this.email);
    },
};
</script>

<style lang="scss" scoped>
$error: #eb6174;

.login-title {
    padding: 5px 0 0;

    p {
        // color: white;
        text-align: left;
        margin: 0;

        &:first-of-type {
            font-size: 36px;
        }
    }
}

.info {
    margin-top: 20px;
    display: flex;
    align-items: center;
    text-align: left;

    img {
        width: 60px;
        opacity: 0.5;
    }

    p {
        font-size: 14px;
        margin: 0 20px;

        span.email {
            font-weight: bold;
            font-size: 16px;
        }
    }
}

.error {
    color: $error;
    font-weight: bold;
}

.success {
    color: #489e95;
    font-weight: bold;
    font-size: 13px;
}

#sign-in-form-1 {
    // margin-top: 50px;
    // width: 500px !important;
    // width: 100%;
    height: 100%;
    z-index: 1;

    .form-body {
        border-radius: 5px;
        text-align: center;
        margin: 10px 0;
        background-color: white;
        min-width: 500px;
        padding: 40px 50px;
        width: 500px;
        // height: 500px;
        display: inline-block;

        @media screen and (max-width: 600px) {
            padding: 40px 10px;
            min-width: 100%;
            width: 100%;
        }

        ::-webkit-input-placeholder {
            /* Edge */
            font-size: 14px;
        }

        :-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            font-size: 14px;
        }

        ::placeholder {
            font-size: 14px;
        }

        .input-container {
            width: 85%;
            // min-width: 350px;
            margin-bottom: 60px;
        }

        .field:not(:last-child) {
            height: 75px;
        }

        .help {
            color: $error !important;
        }

        .label {
            text-align: left;
        }

        .control {
            width: 350px;
            display: inline-block;
        }

        .form-gray {
            color: #9b9b9b;
            font-size: 13px;
        }
    }
}
</style>
